<div class="flex flex-row justify-between items-center">
  <div>
    <h1 mat-dialog-title>{{dialogTitle}}</h1>
  </div>
  <div>
    <button mat-icon-button data-testid="closeEditPlayerLineup" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content>
  <form [formGroup]="playerForm"  >
    <div class="flex flex-col gap-2.5 playerForm">

      @if (data.isEdit) {
        <div class="flex flex-row justify-start items-center gap-2.5">
          <h2 class="dialog-span">{{ fullName }}</h2>
        </div>
      } @else {
        <mat-form-field appearance="outline" color="primary">
          <mat-label>{{ 'components.dialogUpdatePlayerLineup.fullName' | transloco }}</mat-label>
          <input matInput formControlName="fullName"
            placeholder="{{ 'components.dialogUpdatePlayerLineup.fullNamePlaceHolder' | transloco }}" required>
          </mat-form-field>
        }

        <mat-form-field appearance="outline" color="primary">
          <mat-label>{{ 'components.dialogUpdatePlayerLineup.jerseyNumber' | transloco }}</mat-label>
          <input matInput type="number" min="0" max="99" (change)="validateJerseyNumber()" formControlName="jerseyNumber"
            placeholder="{{ 'components.dialogUpdatePlayerLineup.jerseyNumberPlaceHolder' | transloco }}" required>
          </mat-form-field>

          <div class="flex flex-row flex-wrap max-md:flex-col">
            @for (position of footballPositions; track position) {
              <div class="basis-1/2 sm:w-full xl:basis-1/3">
                <mat-checkbox [formControlName]="position">{{position}}</mat-checkbox>
              </div>
            }
            <p>{{ 'components.dialogUpdatePlayerLineup.cocherAuMoinsUnePosition' | transloco }}</p>
          </div>
        </div>
      </form>
    </mat-dialog-content>

    <div mat-dialog-actions>
      <button mat-flat-button data-testid="annulerEditPlayerLineup" mat-button mat-dialog-close>
        {{ 'components.dialogUpdatePlayerLineup.annuler' | transloco }}
      </button>
      <button mat-flat-button color="primary"
        data-testid="saveEditPlayerLineup"
        [disabled]="playerForm.invalid || !atLeastOnePositionChecked()"
        (click)="updatePlayer()">
        {{ 'components.dialogUpdatePlayerLineup.sauvegarder' | transloco }}
      </button>
    </div>
